export default __webpack_public_path__ + "static/media/Twins.0156872c.png";